import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Avatar + author header + body column for one message group.
// Mirrors the mockup's MessageGroup. Right-alignment kicks in when the
// author matches the chat's "current user" — so the user-as-prompter
// reads their own messages on the right, AI + other prompters on the
// left.
import { Children, cloneElement, isValidElement } from "react";
export function MessageGroup({ author, time, currentUser, children }) {
    const isAi = author.role === "ai";
    const isMine = author.id === currentUser;
    const align = isAi ? "left" : isMine ? "right" : "left";
    const variant = computeVariant(author);
    const avatarStyle = !isAi && author.colorVar
        ? {
            background: `var(${author.colorSoft ?? author.colorVar})`,
            borderColor: `color-mix(in oklab, var(${author.colorVar}) 35%, transparent)`,
            color: `var(${author.colorInk ?? author.colorVar})`,
        }
        : undefined;
    const nameStyle = !isAi && author.colorInk ? { color: `var(${author.colorInk})` } : undefined;
    return (_jsxs("div", { className: `mg ${align === "right" ? "mg--right" : ""}`, children: [_jsx("div", { className: `mg__avatar ${isAi ? "mg__avatar--ai" : ""}`, style: avatarStyle, children: author.initials }), _jsxs("div", { className: "mg__col", children: [_jsxs("div", { className: "mg__head", children: [_jsx("span", { className: `mg__name ${isAi ? "mg__name--ai" : ""}`, style: nameStyle, children: author.name }), _jsx("span", { className: "mg__time", children: time })] }), Children.map(children, (child) => isValidElement(child)
                        ? cloneElement(child, {
                            variant,
                            author,
                            isAi,
                            isMine,
                        })
                        : child)] })] }));
}
function computeVariant(author) {
    if (author.role === "ai")
        return "ai";
    // The mockup's color slots are derived from the rosterId; we mirror
    // that mapping here so a four-prompter conversation keeps the four
    // distinct OKLCH families (sienna / teal / violet / moss).
    switch (author.id) {
        case "maya":
            return "user";
        case "jules":
            return "p2";
        case "sana":
            return "p3";
        case "devon":
            return "p4";
        default:
            // Fall back to the dominant prompter palette for unrecognized ids.
            return "user";
    }
}
//# sourceMappingURL=MessageGroup.js.map